import { EntityStatusBadge } from '@frontend/components/badge';
import { UserStateName } from '@frontend/user/types';
import React from 'react';

import { useUserStateBadge } from './user-state-badge.controller';

const ID = 'user-state-badge';

export interface UserStateBadgeProps {
    state: UserStateName;
}

export const UserStateBadge = (props: UserStateBadgeProps) => {
    const viewProps = useUserStateBadge(props);
    return (
        <EntityStatusBadge
            id={ID}
            label={viewProps.displayName}
            variant={viewProps.variant}
        />
    );
};
